module.exports = __webpack_public_path__ + "static/media/ines-mtibaa.83ceb9e0.png";